var exports = {
  "Pf": "AvatarUploader.module__label___SDU4TF",
  "GC": "AvatarUploader.module__buttonGroup___SDU4TF",
  "Ng": "AvatarUploader.module__buttonGroupAfterMode___SDU4TF",
  "gJ": "AvatarUploader.module__errorMessage___SDU4TF",
  "lB": "AvatarUploader.module__spacedParagraph___SDU4TF",
};

module.exports = exports;
